export const breakpoints = {
    min: '320px',
    xxs: '375px',
    xs: '480px',
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    xxl: '1728px',
    uw: '3440px',
};
